import { useEffect, useState } from 'react';
import SectionEventEnergy from 'src/components/sections/section-event/section-event-energy';
import SectionWebull from 'src/components/sections/section-event/section-webull';
import SectionFullH from 'src/components/sections/section-full-h';
import SectionHSide from 'src/components/sections/section-h-side';
import SectionV from 'src/components/sections/section-v';

import _ from 'lodash';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { FiArrowRightCircle } from 'react-icons/fi';
import WidgetBitkub from 'src/components/widgets/widget-bitkub';
import WidgetEventSpecialOne from 'src/components/widgets/widget-event-special-one';
import WidgetExchangeStat from 'src/components/widgets/widget-exchange-stat';
import WidgetGoldStat from 'src/components/widgets/widget-gold-stat';
import WidgetOilStat from 'src/components/widgets/widget-oil-stat';
import { API_URI_BIZELITE, APP_IMG_BIZELITE, APP_URL_BIZELITE, SHOW_COMMEMORATE } from 'src/constants';
import { KEY_ADS_PAGE, KEY_ADS_POSITION } from 'src/utils/ads/dynamic-ads';
import { DATALAYER_TYPE, sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import { convertDatasets } from 'src/utils/datasets';
import { isRender } from 'src/utils/device';
import { convertObjPath, timestamp } from 'src/utils/helper';
import { GET } from 'src/utils/services';
import styled from 'styled-components';
import SectionBitkub from '../section-event/section-bitkub';
import SectionEnergyVer2 from '../section-event/section-energy-ver2';
import SectionPTTVer2 from '../section-event/section-ptt-ver2';
import SectionSchneider from '../section-event/section-schneider';
import { SECTION_TYPE, getSection } from '../section-event/section-schneider/section.service';
import SectionSpacial from '../section-event/section-spacial';
import SectionFull from '../section-full';
import SectionH from '../section-h';
import SectionYoutube from '../section-youtube/section-youtube';

const SectionHalfBookcase = dynamic(import('src/components/sections/section-event/section-half-bookcase'), { ssr: false });
const DynamicAds = dynamic(import('src/utils/ads/dynamic-ads'), { ssr: false });

const SectionTwo = ({
  data,
  spacial,
  sectionOlympic,
  sectionWar,
  sectionBizelite,
  energy = [],
  ads = [],
  sectionEvent,
  dataBitkub,
  iframeoil,
  israelHamas = [],
  sectionPTTVer2,
  sectionEnergyVer2,
  sectionYoutube,
  sectionSevenCateName,
  webull
}) => {
  const [sectionTwoData, setSectionTwoData] = useState(null);
  const [sectionThreeData, setSectionThreeData] = useState(null);
  const [dataSchneider, setDataSchneider] = useState();
  const [specialEvent, setSpecialEvent] = useState();
  const [specialOlympic, setSpecialOlympic] = useState();
  const [specialWar, setSpecialWar] = useState();
  const [specialBizelite, setSpecialBizelite] = useState();
  const router = useRouter();

  const sectionEvDTK = convertDatasets(israelHamas?.dataSet, 'img-desktop', true) || [];
  const sectionEvMB = convertDatasets(israelHamas?.dataSet, 'img-mobile', true) || [];
  const sectionIsCategory = convertDatasets(israelHamas?.dataSet, 'is-category', true) || [];
  const sectionPathName = convertDatasets(israelHamas?.dataSet, 'path-name', true) || [];
  const sectionTitleNameOne = convertDatasets(israelHamas?.dataSet, 'title-name-1', true) || [];
  const sectionTitleNameTwo = convertDatasets(israelHamas?.dataSet, 'title-name-2', true) || [];

  useEffect(() => {
    (async () => {
      try {
        const res = await getSection({ type: SECTION_TYPE.ARTICLE_TAGS, topic: 'section-schneider', limit: 10 });
        if (!_.isEmpty(res)) setDataSchneider({ ...res });

        const response = await Promise.all([
          GET(
            `/api/v1.0/home/section-two${convertObjPath({
              block1: 6,
              block2: 6,
              block3: 6
            })}`
          ),
          GET(
            `/api/v1.0/home/section-three${convertObjPath({
              block1: 6,
              block2: 6,
              block3: 6
            })}`
          )
        ]);
        if (!_.isEmpty(response[0])) setSectionTwoData(response[0]);
        if (!_.isEmpty(response[1])) setSectionThreeData(response[1]);
      } catch (err) {
        console.error(`${timestamp()} ==========> SECTION_TWO ERROR :`, err.message);
      }
    })();
  }, []);

  useEffect(async () => {
    try {
      let specialData;
      if (!_.isEmpty(sectionPathName)) {
        if (sectionIsCategory === 'true') {
          specialData = await GET(`/api/v1.0/categories${sectionPathName}`);
        } else {
          specialData = await GET(`/api/search/tag?name=${sectionPathName}`);
        }
        setSpecialEvent(specialData || []);
      }
    } catch (err) {
      console.error(`${timestamp()} ==========> special ERROR :`, err.message);
    }
  }, [sectionPathName]);
  useEffect(async () => {
    try {
      if (!_.isEmpty(sectionOlympic)) {
        const tagName = convertDatasets(sectionOlympic?.dataSet, 'ชื่อแท็ก', true) || [];

        const data = await GET(`/api/search/tag?name=${tagName}`);
        setSpecialOlympic(data || []);
      }
    } catch (err) {
      console.error(`${timestamp()} ==========> sectionOlympic ERROR :`, err.message);
    }
  }, [sectionOlympic]);

  useEffect(async () => {
    try {
      if (!_.isEmpty(sectionWar)) {
        const tagName = convertDatasets(sectionWar?.dataSet, 'ชื่อแท็ก', true) || [];

        const data = await GET(`/api/search/tag?name=${tagName}`);
        setSpecialWar(data || []);
      }
    } catch (err) {
      console.error(`${timestamp()} ==========> sectionWar ERROR :`, err.message);
    }
  }, [sectionWar]);

  const addBaseUrlToNews = data => {
    if (!Array.isArray(data)) return [];
    return data.map(item => {
      try {
        return {
          ...item,
          image: `${APP_IMG_BIZELITE}${item.image}`,
          vertical_image: `${APP_IMG_BIZELITE}${item.vertical_image}`,
          link: `${APP_URL_BIZELITE}${item.link}`
        };
      } catch (err) {
        console.error('Error patching item id:', item?.id, err);
        return item; // ถ้า error ให้คืนค่าเดิม
      }
    });
  };

  useEffect(async () => {
    try {
      if (!_.isEmpty(sectionBizelite)) {
        const cateName = convertDatasets(sectionBizelite?.dataSet, 'ชื่อแท็ก', true) || [];

        const data = await GET(`${API_URI_BIZELITE}/api/v1.0/categories/${cateName}?limit=4`, true);
        setSpecialBizelite(addBaseUrlToNews(data) || []);
      }
    } catch (err) {
      console.error(`${timestamp()} ==========> sectionBizelite ERROR :`, err.message);
    }
  }, [sectionBizelite]);

  return (
    <>
      <SectionWrapper className='section-olympic' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
        {!_.isEmpty(sectionBizelite) && !_.isEmpty(specialBizelite) && (
          <>
            <SectionSpacial id='spacial-bizelite' data={sectionBizelite}>
              <a className='container spacial-grid'>
                <div className='spacial-grid-list'>
                  <SectionV
                    spacial={sectionBizelite}
                    showSpacial={false}
                    showheading={false}
                    count={4}
                    badge={false}
                    external={true}
                    withTarget={true}
                    data={specialBizelite}
                    heading={convertDatasets(sectionBizelite?.dataSet, 'ชื่อแท็ก', true)}
                    path={''}
                    //! DATALAYER
                    eventDataLayer={{
                      type: DATALAYER_TYPE.TRACK_POSITION,
                      router: router?.pathname,
                      section: 'section-spacial',
                      position: 'ใต้:ข่าวล่าสุด',
                      data: {
                        heading: convertDatasets(sectionBizelite?.dataSet, 'ชื่อแท็ก', true)
                      }
                    }}
                  />
                </div>
              </a>
              <a target='_blank' href={`${convertDatasets(sectionBizelite?.dataSet, 'link', true)}`} className='more'>
                ดูทั้งหมด <FiArrowRightCircle />
              </a>
            </SectionSpacial>
          </>
        )}
        {!_.isEmpty(sectionWar) && (
          <>
            <SectionSpacial id='spacial-war' data={sectionWar}>
              <a className='container spacial-grid'>
                <div className='spacial-grid-list'>
                  <SectionV
                    spacial={sectionWar}
                    showSpacial={false}
                    showheading={false}
                    count={4}
                    data={specialWar}
                    heading={convertDatasets(sectionWar?.dataSet, 'ชื่อแท็ก', true)}
                    path={''}
                    //! DATALAYER
                    eventDataLayer={{
                      type: DATALAYER_TYPE.TRACK_POSITION,
                      router: router?.pathname,
                      section: 'section-spacial',
                      position: 'ใต้:ข่าวล่าสุด',
                      data: {
                        heading: convertDatasets(sectionWar?.dataSet, 'ชื่อแท็ก', true)
                      }
                    }}
                  />
                </div>
                <a href={`tags/${convertDatasets(sectionWar?.dataSet, 'ชื่อแท็ก', true)}`} className='more'>
                  ดูทั้งหมด <FiArrowRightCircle />
                </a>
              </a>
            </SectionSpacial>
          </>
        )}
      </SectionWrapper>
      {isRender('mobile') ? (
        <DynamicAds page={KEY_ADS_PAGE.HOMEPAGE} position={KEY_ADS_POSITION.INARTICLE_2} data={ads} />
      ) : (
        <DynamicAds page={KEY_ADS_PAGE.HOMEPAGE} position={KEY_ADS_POSITION.INARTICLE_1} data={ads} />
      )}

      {!_.isEmpty(data?.tags) && (
        <section id='section-4' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
          <div className='container'>
            <div className='tags-area --homepage '>
              <div className='post-tags'>
                <span>แท็กยอดนิยม</span>
                {data.tags.map((item, i) => (
                  <a
                    key={i}
                    href={`/tags/${item.name}`}
                    //! DATALAYER
                    onClick={() =>
                      sendDataLayerGlobal({
                        type: DATALAYER_TYPE.TRACK_POSITION,
                        router: router?.pathname,
                        section: 'section-แท็กยอดนิยม',
                        position: isRender('mobile') ? 'ใต้:โฆษณาตำแหน่ง inarticle-2' : 'ใต้:โฆษณาตำแหน่ง inarticle-1',
                        data: {
                          heading: 'แท็กยอดนิยม',
                          title: item.name,
                          index: i + 1
                        }
                      })
                    }
                  >
                    {item.name}
                  </a>
                ))}
              </div>
            </div>
          </div>
          <SectionWrapper className='section-sustainability' bgSustainability={_.find(sectionEvent, { key: 'background-image' })?.value}>
            {data.block1.title === convertDatasets(spacial?.dataSet || [], 'ชื่อแท็ก', true) ? (
              <>
                {!_.isEmpty(spacial) ? (
                  <>
                    <SectionSpacial id='spacial' data={spacial}>
                      <div className='container spacial-grid'>
                        <div className='spacial-grid-list'>
                          <SectionV
                            spacial={spacial}
                            showSpacial={true}
                            showheading={false}
                            count={2}
                            data={data.block1.data}
                            heading={data.block1.title}
                            path={data.block1.link}
                            //! DATALAYER
                            eventDataLayer={{
                              type: DATALAYER_TYPE.TRACK_POSITION,
                              router: router?.pathname,
                              section: 'section-spacial',
                              position: 'ใต้:แท็กยอดนิยม',
                              data: {
                                heading: data.block1.title
                              }
                            }}
                          />
                        </div>
                      </div>
                    </SectionSpacial>
                  </>
                ) : (
                  ' '
                )}
              </>
            ) : (
              <>
                <Sustainwrapper className='container'>
                  <div className='row'>
                    <div className='col-12'>
                      <SectionV
                        sectionEvent={sectionEvent}
                        data={data.block1.data}
                        heading={data.block1.title}
                        path={data.block1.link}
                        isSustain={true}
                        more={true}
                        //! DATALAYER
                        eventDataLayer={{
                          type: DATALAYER_TYPE.TRACK_POSITION,
                          router: router?.pathname,
                          section: 'section-4',
                          position: isRender('mobile') ? 'ใต้:section-3' : 'ใต้:แท็กยอดนิยม',
                          data: {
                            heading: data.block1.title
                          }
                        }}
                      />
                    </div>
                  </div>
                </Sustainwrapper>
              </>
            )}
            {/* {!_.isEmpty(_.find(sectionEvent, { key: 'footer-image-left' })?.value) && !_.isEmpty(_.find(sectionEvent, { key: 'footer-image-right' })?.value) ? (
              <FooterWrapper className='footer-wrapper container'>
                {!_.isEmpty(_.find(sectionEvent, { key: 'footer-image-left' })?.value) ? (
                  <img className='footer-image-left' src={_.find(sectionEvent, { key: 'footer-image-left' })?.value} width='100%' height='100%' />
                ) : null}
                {!_.isEmpty(_.find(sectionEvent, { key: 'footer-image-right' })?.value) ? (
                  <img className='footer-image-right' src={_.find(sectionEvent, { key: 'footer-image-right' })?.value} width='100%' height='100%' />
                ) : null}
              </FooterWrapper>
            ) : null} */}
            {!_.isEmpty(webull) && (
              <SectionWebull
                id='section-webull'
                data={webull}
                //! DATALAYER
                eventDataLayer={{
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  section: 'section-4',
                  position: isRender('mobile') ? 'ใต้:section-3' : 'ใต้:แท็กยอดนิยม',
                  data: {
                    heading: data.block1.title
                  }
                }}
              />
            )}
          </SectionWrapper>
        </section>
      )}
      <section id='section-5' className='container pt-0' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
        <div className='row'>
          {!_.isEmpty(data?.block2?.data) && (
            <div className='col-lg-8 col-md-12'>
              <SectionFull
                sectionEvent={sectionEvent}
                data={data.block2.data}
                heading={data.block2.title}
                path={data.block2.link}
                count={4}
                sectionCol='col-6 my-2'
                //! DATALAYER
                eventDataLayer={{
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  section: 'section-5',
                  position: 'ใต้:section-4',
                  data: {
                    block: '1',
                    heading: data.block2.title
                  }
                }}
              />
            </div>
          )}
          {!_.isEmpty(data?.block3?.data) && (
            <div className='col-lg-4 col-md-12 mt-5 section-money'>
              <SectionFullH
                data={data.block3}
                count={4}
                path={data.block3.link}
                heading={data.block3.title}
                //! DATALAYER
                eventDataLayer={{
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  section: isRender('mobile') ? 'section-6' : 'section-5',
                  position: isRender('mobile') ? 'ใต้:section-5' : 'ใต้:section-4',
                  data: {
                    block: '2',
                    heading: data.block3.title
                  }
                }}
              />
            </div>
          )}
        </div>
      </section>
      {!_.isEmpty(specialEvent) ? (
        <BgEvent bgDesktop={`${sectionEvDTK}`} bgMobile={`${sectionEvMB}`} style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
          {!_.isEmpty(sectionTitleNameOne) && (
            <div className='event-detail'>
              <p className='special-title-one'>{sectionTitleNameOne}</p>
            </div>
          )}
          {!_.isEmpty(sectionTitleNameTwo) && (
            <div className='event-detail'>
              <p className='special-title-two'>{sectionTitleNameTwo}</p>
            </div>
          )}
          <div className='container'>
            <div className='row'>
              <div className='col-12'>
                <WidgetEventSpecialOne
                  data={specialEvent}
                  heading={sectionPathName}
                  path={sectionIsCategory === 'true' ? `category/${sectionPathName} ` : `/tags/${sectionPathName}`}
                  //! DATALAYER
                  eventDataLayer={{
                    type: DATALAYER_TYPE.TRACK_POSITION,
                    router: router?.pathname,
                    section: 'section-event',
                    position: isRender('mobile') ? 'ใต้:section-6' : 'ใต้:section-5',
                    data: {
                      heading: sectionPathName
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </BgEvent>
      ) : null}

      <section id='section-youtube' className='container' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
        {!_.isEmpty(sectionYoutube) && (
          <SectionYoutube
            sectionYoutube={sectionYoutube}
            //! DATALAYER
            eventDataLayer={{
              type: DATALAYER_TYPE.TRACK_POSITION,
              router: router?.pathname,
              section: 'section-youtube',
              position: 'ใต้:section-12'
            }}
          />
        )}
      </section>
      <SectionSchneider
        id='section-schneider'
        data={dataSchneider}
        //! DATALAYER
        eventDataLayer={{
          type: DATALAYER_TYPE.TRACK_POSITION,
          router: router?.pathname,
          section: 'section-spacial',
          position: 'ใต้:section-new-bookcase',
          data: {
            heading: 'Green Heroes for Life'
          }
        }}
      />

      {/* ------------------------ PTT Section Ver.2----------------------- */}
      <SectionPTTVer2 data={sectionPTTVer2} />
      <section id='section-bitkub' className='container' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
        <div className='row'>
          <div className='col-lg-7 col-md-12'>
            <div className='widget-oil'>
              {!_.isEmpty(iframeoil) && !_.isEmpty(iframeoil?.dataSet) && <WidgetOilStat iframeoil={iframeoil?.dataSet} />}
              <div className='widget-gold-exchange'>
                <WidgetGoldStat />
                <WidgetExchangeStat />
              </div>
            </div>
          </div>
          <div className='col-lg-5 col-md-12 pt-md-4 pt-0'>
            <WidgetBitkub />
          </div>
        </div>
      </section>
      <section id='section-6' className='container pt-0' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
        <div className='row'>
          <div className='col-lg-8 col-md-12'>
            {!_.isEmpty(sectionTwoData?.block1?.data) && (
              <SectionHSide
                data={sectionTwoData.block1}
                path={sectionTwoData.block1.link}
                heading={sectionTwoData.block1.title}
                //! DATALAYER
                eventDataLayer={{
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  section: 'section-6',
                  position: 'ใต้:section-spacial (bitkub)',
                  data: {
                    block: '1',
                    heading: sectionTwoData.block1.title
                  }
                }}
              />
            )}
          </div>

          <div className='col-lg-4 col-md-12 section-money'>
            {!_.isEmpty(sectionTwoData?.block2?.data) && (
              <SectionH
                data={sectionTwoData.block2.data}
                path={sectionTwoData.block2.link}
                heading={sectionTwoData.block2.title}
                //! DATALAYER
                eventDataLayer={{
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  section: 'section-6',
                  position: 'ใต้:section-spacial (bitkub)',
                  data: {
                    block: '2',
                    heading: sectionTwoData.block2.title
                  }
                }}
              />
            )}
          </div>
        </div>
      </section>
      <SectionWrapper className='section-olympic' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
        {!_.isEmpty(sectionOlympic) && (
          <>
            <SectionSpacial id='spacial' data={sectionOlympic}>
              <a className='container spacial-grid'>
                <div className='spacial-grid-list'>
                  <SectionV
                    spacial={sectionOlympic}
                    showSpacial={false}
                    showheading={false}
                    count={4}
                    data={specialOlympic}
                    heading={convertDatasets(sectionOlympic?.dataSet, 'ชื่อแท็ก', true)}
                    path={''}
                    //! DATALAYER
                    eventDataLayer={{
                      type: DATALAYER_TYPE.TRACK_POSITION,
                      router: router?.pathname,
                      section: 'section-spacial',
                      position: 'ใต้:ข่าวล่าสุด',
                      data: {
                        heading: convertDatasets(sectionOlympic?.dataSet, 'ชื่อแท็ก', true)
                      }
                    }}
                  />
                </div>
                <a href={`tags/${convertDatasets(sectionOlympic?.dataSet, 'ชื่อแท็ก', true)}`} className='more'>
                  ดูทั้งหมด <FiArrowRightCircle />
                </a>
              </a>
            </SectionSpacial>
          </>
        )}
      </SectionWrapper>
      {/* sectionBitkub */}
      {!_.isEmpty(dataBitkub) && (
        <SectionBitkub
          dataBitkub={dataBitkub}
          eventDataLayer={{
            type: DATALAYER_TYPE.TRACK_POSITION,
            router: router?.pathname,
            section: 'section-spacial',
            position: 'ใต้:section-6',
            data: {
              heading: 'Bitkub'
            }
          }}
        />
      )}
      <SectionEventEnergy
        energy={energy}
        //! DATALAYER
        eventDataLayer={{
          type: DATALAYER_TYPE.TRACK_POSITION,
          router: router?.pathname,
          section: 'section-spacial',
          position: 'ใต้:section-6'
        }}
      />
      {/* ------------------------ PTT Energy Ver2 ----------------------- */}
      {/* {isRender('desktop') && <SectionEnergyVer2 data={sectionEnergyVer2} />} */}
      <SectionEnergyVer2 data={sectionEnergyVer2} />
      <section id='section-7' className='container pb-4' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
        <div className='row'>
          <div className='col-lg-8 col-md-12'>
            {!_.isEmpty(sectionThreeData?.block1?.data) && (
              <SectionHSide
                data={sectionThreeData.block1}
                path={sectionThreeData.block1.link}
                heading={sectionThreeData.block1.title}
                count={5}
                //! DATALAYER
                eventDataLayer={{
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  section: 'section-7',
                  position: 'ใต้:section-6',
                  data: {
                    block: '1',
                    heading: sectionThreeData.block1.title
                  }
                }}
              />
            )}
          </div>

          <div className='col-lg-4 col-md-12'>
            <DynamicAds position={KEY_ADS_POSITION.STICKY_1} data={ads} />
            {!_.isEmpty(sectionTwoData?.block3?.data) ? (
              <SectionH
                data={sectionTwoData.block3?.data}
                path={sectionTwoData.block3.link}
                heading={sectionTwoData.block3.title}
                //! DATALAYER
                eventDataLayer={{
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  section: 'section-7',
                  position: 'ใต้:section-6',
                  data: {
                    block: '2',
                    heading: sectionTwoData.block3.title
                  }
                }}
              />
            ) : null}
            {/* <div className='slide-ea'>
              <SliderFull
                data={[...new Array(3)]}
                type='events'
                dataSrc='/events/EA/E'
                more={[
                  { id: 1, link: 'https://www.facebook.com/minebusth' },
                  { id: 2, link: 'https://www.facebook.com/eaanywhere.th' },
                  { id: 3, link: 'https://www.facebook.com/MINESmartFerry' }
                ]}
                settings={{
                  dots: true,
                  arrows: true,
                  infinite: true,
                  autoplay: true,
                  speed: 500,
                  slidesToShow: 1,
                  slidesToScroll: 1
                }}
                headingDatalayer='EA'
                //! DATALAYER
                eventDataLayer={{
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  section: 'section-6',
                  position: 'ใต้:section-spacial (bitkub)',
                  data: {
                    block: '3',
                    heading: 'Events EA'
                  }
                }}
              />
            </div> */}
          </div>

          <div className='col-lg-8 col-md-12'>
            {!_.isEmpty(sectionThreeData?.block2?.data) && (
              <SectionV
                data={sectionThreeData.block2.data}
                path={sectionThreeData.block2.link}
                count={6}
                sectionCol='col-lg-4 col-md-6 col-6'
                heading={sectionThreeData.block2.title}
                //! DATALAYER
                eventDataLayer={{
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  section: 'section-7',
                  position: 'ใต้:section-6',
                  data: {
                    block: '2',
                    heading: sectionThreeData.block2.title
                  }
                }}
              />
            )}
          </div>

          <div className='col-lg-4 col-md-12'>
            {!_.isEmpty(sectionThreeData?.block3?.data) && (
              <SectionFullH
                data={sectionThreeData.block3}
                path={sectionThreeData.block3.link}
                count={3}
                heading={sectionThreeData.block3.title}
                //! DATALAYER
                eventDataLayer={{
                  type: DATALAYER_TYPE.TRACK_INDEX,
                  router: router?.pathname,
                  section: 'section-7',
                  position: 'ใต้:section-6',
                  data: {
                    block: '3',
                    heading: sectionThreeData.block3.title
                  }
                }}
              />
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default SectionTwo;

const SectionWrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 30px 0;
  background: rgb(255, 255, 255);
  background-image: url(${props => props.bgSustainability});
  /* background: rgb(66,158,21); */
  /* background: ${props => `${props.bgSustainability ? 'radial-gradient(circle, rgba(255,255,255,1) 10%, rgba(60,166,73,1) 100%)' : ''}`}; */
  @media (max-width: 767px) {
    /* background: radial-gradient(circle, rgba(255, 255, 255, 1) 0%, rgba(166, 240, 186, 1) 61.6305%, rgba(93, 202, 242, 1) 100%); */
    padding: 40px 0 20px 0;
  }
  &.section-olympic {
    padding: 0;
    .more {
      color: #fff;
      position: absolute;
      bottom: 20px;
      right: 30px;
      :hover {
        color: #ffffff92;
      }
    }
    #spacial {
      background-position: center;
      @media (min-width: 767px) and (max-width: 1024px) {
        background-size: contain;
        background-position: top center;
        background-color: #796164;
      }

      .spacial-grid {
        padding: 15rem 1rem 2rem;
        @media (max-width: 1024px) {
          padding: 8rem 1rem 0rem;
        }
      }
      .spacial-card {
        border-radius: 8px;
      }
      .spacial-grid-list .row {
        grid-gap: 20px;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        @media (max-width: 1024px) {
          grid-template-columns: 1fr 1fr;
          grid-template-areas: '--item-1 --item-2' '--item-3 --item-4';
        }
      }
    }
    #spacial-bizelite {
      position: relative;
      .spacial-grid {
        padding: 12rem 1rem 2rem !important;
        @media (max-width: 1024px) {
          padding: 10rem 1rem 0rem !important;
        }
      }
        .card-v-content-meta {
        margin-top: 5px;
        }
        .card-v-thumb {
            margin-bottom: 10px;
        }
      .more {
        color: #fff;
        position: absolute;
        bottom: 20px;
        right: 30px;
        :hover {
          color: #ffffff92;
        }
      }
    }
    #spacial-bizelite,
    #spacial-war {
      background-position: center;
      @media (min-width: 767px) and (max-width: 1024px) {
        background-size: contain;
        background-position: top center;
        background-color: white;
      }

      .spacial-grid {
        padding: 20rem 1rem 2rem;
        @media (max-width: 1024px) {
          padding: 11rem 1rem 0rem;
        }
      }
      .spacial-card {
        border-radius: 8px;
      }
      .spacial-grid-list .row {
        grid-gap: 20px;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        @media (max-width: 1024px) {
          grid-template-columns: 1fr 1fr;
          grid-template-areas: '--item-1 --item-2' '--item-3 --item-4';
        }
      }
    }
  }
`;

const Sustainwrapper = styled.div`
  .block-wrapper {
    margin-bottom: 0;
    .card-v {
      margin-bottom: 0;
      @media (max-width: 992px) {
        margin-bottom: 20px;
      }
      .pageview {
        background-color: unset !important;
      }
    }
  }
`;
const BgEvent = styled.div`
  background: ${props => `url(${props?.bgDesktop})`};
  background-attachment: scroll;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  padding: 20px 0;
  @media (max-width: 1024px) {
    background: ${props => `url(${props?.bgMobile})`};
    background-size: cover;
    background-repeat: no-repeat;
  }
  @media (max-width: 690px) {
    padding: 10px 0;
  }

  .block-wrapper .block-title {
    border-bottom: 2px dotted #fff;
  }

  .event-detail {
    text-align: center;
    .special-title-one {
      color: #fff;
      font-size: 42px;
      line-height: 1.2;
      @media (max-width: 690px) {
        font-size: 32px;
      }
    }
    .special-title-two {
      line-height: 0.8;
      color: #ed1c24;
      font-size: 64px;
      font-weight: 500;
      filter: drop-shadow(2px 4px 0px rgba(0, 0, 0, 0.5));
      @media (max-width: 690px) {
        font-size: 42px;
      }
    }
  }
  .block-wrapper {
    margin-bottom: 0;
  }
  .block-title {
    border-bottom: unset;
    justify-content: flex-end;
    margin-bottom: 0;
    h2 {
      display: none;
    }
    a {
      color: #fff !important;
      padding: 10px 15px;
      border-radius: 10px 10px 0 0px;
      font-size: 14px;
      margin-bottom: -2px;
      svg {
        color: #fff !important;
      }
    }
  }

  .block-content {
    .card-v {
      &:hover {
        h3 {
          color: #ffffff92 !important;
        }
      }
    }
    .card-v-thumb {
      &:before {
        /* background: -moz-linear-gradient(bottom, rgba(0, 0, 0, 0) 60%, #0600E7 100%);
        background: -webkit-gradient(linear, left bottom, left bottom, color-stop(60%, rgba(0, 0, 0, 0)), color-stop(100%, #0600E7));
        background: -webkit-linear-gradient(bottom, rgba(0, 0, 0, 0) 60%, #0600E7 100%);
        background: -o-linear-gradient(bottom, rgba(0, 0, 0, 0) 60%, #0600E7 100%);
        background: -ms-linear-gradient(bottom, rgba(0, 0, 0, 0) 60%, #0600E7 100%);
        background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 60%, #0600E7 100%); */
      }
    }
    .card-v-content {
      h3 {
        color: #fff;
        transition: all 0.3s ease-in-out;
        &:hover {
          color: #ffffff92 !important;
        }
      }
    }
  }
`;
